import { useCallback, useEffect, useState } from 'react'
import { useParams } from 'react-router'
import { LeaveRequest } from '../../../../database/tables'
import LeaveRequestService from '../../../../services/leave-request'
import { FetchStatus } from '../../../../types/fetch-status.types'
import constants from '../../../../constants'
import * as dateFns from 'date-fns'
import adminLeaveRequestApprovalPopupStore from '../../../../store/adminLeaveRequestApprovalPopupStore'
import { ApprovalStatus } from '../../../../database/enums/ApprovalStatus.enum'
import PERMISSIONS from '../../../../private/permissions'
import authStore from '../../../../store/authStore'
import toast from 'react-hot-toast'

export default function useAdminLeaveRequestDetailViewModel() {
  const params = useParams()
  const id = params.id as string | null
  const user = authStore(state => state.user)

  const [dataFetchStatus, setDataFetchStatus] = useState<FetchStatus>(constants.fetchStatus.default)
  const [detailData, setDetailData] = useState<LeaveRequest | null>(null)

  const canApproval = useCallback(() => {
    if (!!user && !!user.email) return PERMISSIONS.getApprovalEmails().includes(user.email)
    return false
  }, [user])()

  async function fetchDetailData() {
    if (!!id) {
      setDataFetchStatus({ ...constants.fetchStatus.default, isLoading: true })
      await LeaveRequestService.getById({ id })
        .then(res => {
          setDataFetchStatus({ ...constants.fetchStatus.default, isSuccess: true })
          setDetailData(res)
        })
        .catch(error => {
          console.log(error)
          setDataFetchStatus({ ...constants.fetchStatus.default, isError: true })
        })
    }
  }

  function getDateValue(startDate: Date, endDate: Date): string {
    if (dateFns.differenceInCalendarDays(startDate, endDate))
      return `${dateFns.format(startDate, constants.dateFormats.basicReadable)} - ${dateFns.format(endDate, constants.dateFormats.basicReadable)}`
    else return dateFns.format(startDate, constants.dateFormats.basicReadable)
  }

  useEffect(() => {
    fetchDetailData()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id])

  function onApproveClick() {
    if (canApproval)
      adminLeaveRequestApprovalPopupStore.setState({
        approvalStatus: ApprovalStatus.APPROVED,
        data: detailData,
        open: true,
      })
    else toast.error("You don't have permission to do this action!")
  }

  function onRejectClick() {
    if (canApproval)
      adminLeaveRequestApprovalPopupStore.setState({
        approvalStatus: ApprovalStatus.REJECTED,
        data: detailData,
        open: true,
      })
    else toast.error("You don't have permission to do this action!")
  }

  function onApprovalPopupConfirm() {
    fetchDetailData()
  }

  return {
    id,
    detailData,
    dataFetchStatus,
    canApproval,
    getDateValue,
    onApproveClick,
    onRejectClick,
    onApprovalPopupConfirm,
  }
}
